import script from "./CardList.vue?vue&type=script&setup=true&lang=js"
export * from "./CardList.vue?vue&type=script&setup=true&lang=js"

import "./CardList.vue?vue&type=style&index=0&id=2334e3ba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2334e3ba"]])

export default __exports__